import { Pipe, PipeTransform } from '@angular/core';

import { AttributeValueReplaceListModel } from 'src/app/model/shared/pipe/attribute-value-replace';

@Pipe({
  name: 'attributeValueReplace'
})
export class AttributeValueReplacePipe implements PipeTransform {

  transform(value: string, replaceList: AttributeValueReplaceListModel[]): string {
    let returnValue = value;
    if (replaceList?.length) {
      returnValue = replaceList?.find(item => item?.value === value)?.label;
    }
    return returnValue;
  }

}
